import {callURL} from './call';
import messageShow from "./messageShow";
import {signerURL} from "../url";
import {push} from "connected-react-router";
import {VALIDATE_ROUTE} from "../components/Root/routes";
import _ from 'lodash';

const newpassword= (formValues) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            dispatch(push(VALIDATE_ROUTE + '?userName='+ formValues.userName));
            dispatch(messageShow({message: 'Password cambiado correctamente', type: 'success'}));
        }
        else
            dispatch(messageShow({message: result[1].error, type: 'error'}));
    }
    dispatch(callURL(signerURL,"rest/UserService/newPassword",_.omit(formValues,'userName'),onResult));
};
export default newpassword;